<template>
  <div class="content">
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 附加单据
      </h3>
      <div class="tu-class">
        <!-- <p v-html="strnei" >{{strnei}}</p> -->
        <CustomerInformation  ref="childForm"  v-if="fromType == 1" :childId="id" :childProcessId="processId" :fromType="1"></CustomerInformation>
        <ShippingInformation  ref="childForm"  v-if="fromType == 2" :childId="id" :childProcessId="processId" :fromType="2"  :form-data.sync="childFormData"></ShippingInformation>
        <OutEntrepot  ref="childForm"  v-if="fromType == 3" :childId="id" :childProcessId="processId" :fromType="3" ></OutEntrepot>
      </div>
    </div>
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 流程图
      </h3>
      <div class="tu-class">
        <p v-html="str" class="p-class">{{str}}</p>
      </div>
    </div>
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 审批意见
        <div class="nr-class">
          <el-select v-model="queryParams.status" filterable placeholder="审批结果" clearable>
            <el-option v-for="item in source" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <p class="yjp-class">
            <el-input type="textarea" :rows="4" v-model="queryParams.remark" placeholder="请输入备注意见" style="width:50%"></el-input>
          </p>
          <el-button type="primary" @click="submit" style="margin-top: 20px;">提交</el-button>
        </div>
      </h3>
    </div>
  </div>
</template>
<script>
import { processInstanceImage } from "@/api/api.js";//流程图
import { submitTask } from "@/api/api.js";//审批意见提交
import ShippingInformation from '../../components/flowForm/shippingInformation.vue';
import CustomerInformation from '../../components/flowForm/customerInformation.vue';
import OutEntrepot from '../../components/flowForm/outEntrepot.vue';

export default {
  components: {  ShippingInformation,CustomerInformation,OutEntrepot},
  name:'processTransaction',
  data() {
    return{
      fromType:1,
      processId:'',
      id:'',
      str:"",
      strnei:"",
      childFormData:{},
      queryParams:{
        remark:""
      },
      source:[
        {
          value:1,
          label:"同意"
        },
        {
          value:2,
          label:"不同意"
        },
      ],
      url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/uploadImage',
      gaibianurl: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/image/',
      file:""
    }
  },

  methods: {

    // 获取数据
    initData(){
      let params ={
        processInstanceId:this.processId
      }
      processInstanceImage(params).then(res=>{
        this.str = res.data
      });
      // processFromData(params).then(res=>{
      //   if (res.data.code == 200) {
      //     this.fromData = res.data.data;
      //   }
      // })
    },
    handleAvatarSuccess(res, file){
    //   if(res.code == 200){
    //     this.queryParams.remark = this.gaibianurl + res.data;
    //   }
    },
    // 提交
    submit(){
      if (!this.queryParams.remark||!this.queryParams.status) return this.$message.error("请输入审批内容或结果");
      let params = {
        ...this.queryParams,
        taskId:this.id,
      }
      if(this.fromType == 1 ){
        params.userName = this.$refs.childForm.userName
        params.customerInformationDto = this.$refs.childForm.formData
      }else if(this.fromType == 2){
        params.shipmentRequestDto =  this.$refs.childForm.formData
      }else if(this.fromType == 3){
        params.outEntrepot = this.$refs.childForm.formData
      }
      submitTask(params).then(res=>{
        if(res.data.code == 200){
          this.$router.push({ path: `/personalOffice/myMission` });
          this.$notify({
            title: '成功',
            message: '审批成功',
            type: 'success'
          });
        }
      })
    }
  },
  created() {
    this.processId =  this.$route.query.processId ;
    this.id =  this.$route.query.id ;
    this.fromType = this.$route.query.fromType
    // this.initData()
  },
  mounted() {
    this.initData()
  },
};
</script>
<style scoped lang="less">
.zhantie{
  width: 50%;
  height: 230px;
  border: 1px solid #DCDFE6;
  overflow: hidden;
  margin-top: 22px;
  background: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  span{
    font-size:14px;
    color: #C0C4CC;
  }
}
.imgclass{
  width: 300px;
  height: 100px;
}
.lct-class{
  padding-bottom: 50px;
  .detail-h3 {
    font-size: 20px;
    color: #000000;
    padding-bottom: 30px;
    box-sizing: border-box;
  }
  .detail-h3 i {
    color: #5298ff;
  }
  .nr-class{
    margin-top: 20px;
    margin-left: 10px;
  }
  .yjp-class{
    margin-top: 20px;
  }
}
</style>


